<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="addMrTaskDialog">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-borderBox h-filterTopoTree height-620'>
              <MrGnbTopoTree @pmGnbTopoTreeClickEventPush="pmGnbTopoTreeClickEventPush" ref='pmGnbTopoTreeRef' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="2"></MrGnbTopoTree>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.measureType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="measureType" v-model="measureType">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.omcName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="omcName" v-model="omcName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.samplePeriod')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="samplePeriod" v-model="samplePeriod">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.uploadPeriod')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="uploadPeriod" v-model="uploadPeriod">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.sampleBeginTime')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-datetimepicker v-model='sampleBeginTime' name='sampleBeginTime' :locale='locale' format='yyyy-MM-dd HH:mm:ss' :step='15' timeFormat='HH:mm:ss' :allowEdit='false'></ejs-datetimepicker>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.sampleEndTime')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-datetimepicker v-model='sampleEndTime' name='sampleEndTime' :locale='locale' format='yyyy-MM-dd HH:mm:ss' :step='15' timeFormat='HH:mm:ss' :allowEdit='false'></ejs-datetimepicker>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.prbNum')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="prbNum" v-model="prbNum">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.subFrameNum')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="subFrameNum" v-model="subFrameNum">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('MR.alias')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" id="alias" name="alias" v-model="alias">
            </div>
          </div>
        </div>
        <div class='h-clear-rowMg'></div>
      </div>
    </form>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import MrGnbTopoTree from "../tree/MrGnbTopoTree";
  import DateUtil from "../../../pmConfig/util/DateUtil";

  export default {
    name: 'AddMeasureTaskDialog',
    components: {
      MrGnbTopoTree,
      DateUtil
    },
    data() {
      return {
        dateFormat: 'yyyy-MM-dd',
        measureType: '',
        omcName: '',
        samplePeriod: '',
        uploadPeriod: '',
        sampleBeginTime: '',
        sampleEndTime: '',
        prbNum: '',
        subFrameNum: '',
        alias: '',
        locale: localStorage.getItem('locale'),
        neClickInfo: null,
        addMrTaskValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            measureType: {
              required: [true, this.$t('MR.noNull')],
            },
            omcName: {
              required: [true, this.$t('MR.noNull')],
            },
            samplePeriod: {
              required: [true, this.$t('MR.noNull')],
            },
            uploadPeriod: {
              required: [true, this.$t('MR.noNull')],
            },
            sampleBeginTime: {
              required: [true, this.$t('MR.noNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('MR.timeFormatError')]
            },
            sampleEndTime: {
              required: [true, this.$t('MR.noNull')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('MR.timeFormatError')]
            },
            prbNum: {
              required: [true, this.$t('MR.noNull')],
            },
            subFrameNum: {
              required: [true, this.$t('MR.noNull')],
            },
            alias: {
              required: [true, this.$t('MR.noNull')],
            }
          }
        },
        formObjOfAddMrTask: ''
      }
    },
    methods: {
      bindValidateOfAddMrTask(){
        this.formObjOfAddMrTask = new FormValidator('#addMrTaskDialog', this.addMrTaskValidation);
      },

      validateOfAddMrTask() {
        const formStatus = this.formObjOfAddMrTask.validate();
        console.log("formStatus",formStatus)
        if (!formStatus) {
          return false;
        }
        return true;
      },

      pmGnbTopoTreeClickEventPush(params) {
        this.neClickInfo = {};
        this.neClickInfo = params;
      },
      getMrTaskData() {
        console.log("this.sampleBeginTime",this.sampleBeginTime)
        return {
          measureType: this.measureType,
          omcName: this.omcName,
          samplePeriod: this.samplePeriod,
          uploadPeriod: this.uploadPeriod,
          sampleBeginTime: DateUtil.getTr069DateString(this.sampleBeginTime),
          sampleEndTime: DateUtil.getTr069DateString(this.sampleEndTime),
          prbNum: this.prbNum,
          subFrameNum: this.subFrameNum,
          neIp: this.neClickInfo.attribute.neIp,
          nePort: this.neClickInfo.attribute.nePort,
          cpeId: this.neClickInfo.attribute.neName,
          neId: this.neClickInfo.attribute.neId
                }
            }, 
    },
    mounted() {
      this.bindValidateOfAddMrTask();
    }
  }
</script>

<style scoped>
</style>
